import { createContext, useContext, useState } from "react";

const PatientContext = createContext();

export const PatientProvider = ({ children }) => {
  const [patientDetails, setPatientDetails] = useState([]);
  const [patientTimeline, setPatientTimeline] = useState([]);

  const updatePatientDetails = (newDetails) => {
    setPatientDetails(newDetails);
  };

  const updatePatientTimeline = (newTimeline) => {
    setPatientTimeline(newTimeline);
  };

  return (
    <PatientContext.Provider
      value={{
        patientDetails,
        patientTimeline,
        updatePatientDetails,
        updatePatientTimeline,
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};

export const usePatientContext = () => {
  return useContext(PatientContext);
};
